export const WA_NUMBER = "6287781897759";
export const WA_DISPLAY = "0877-8189-7759";

export const STORE = {
  name: "BigBerry Store",
  tagline: "Premium Reseller",
  domain: "www.bigberrystore.com",
  url: "https://www.bigberrystore.com",
  address:
    "Jalan Boulevard Raya Barat Blk C25, RT.2/RW.9, Klp. Gading Bar., Kec. Klp. Gading, Jakarta Utara, DKI Jakarta 14240",
  hours: "Setiap hari, 09.00 - 20.00 WIB",
  social: {
    instagram: "https://instagram.com/bigberrystore",
    threads: "https://threads.net/@bigberrystore",
    tiktok: "https://tiktok.com/@bigberrystore",
  },
};

export const BNPL = ["Kredivo", "Akulaku", "Indodana", "Yeskredit", "Kartu Kredit"];

export const BRANDS = [
  "Apple", "Samsung", "Google", "GoPro", "JBL",
  "Bose", "Harman Kardon", "Meta", "Microsoft", "Beats", "Lainnya",
];

export function waLink(productName) {
  const text = productName
    ? `Halo BigBerry, saya mau tanya soal ${productName}`
    : "Halo BigBerry, saya mau tanya soal produk yang tersedia";
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function formatPrice(price) {
  if (price === null || price === undefined || price === 0) return null;
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(price);
}
